export const roles = {
  VERSAR_ADMIN: 'administrator',
  SCHOOL_ADMIN: 'school_administrator',
  CONTENT_CREATOR: 'content_creator',
  TEACHER: 'teacher',
  SCHOOL_MODERATOR: 'school_moderator',
  CLASSROOM_MODERATOR: 'classroom_moderator',
  COORDINATOR: 'coordinator',
  PARENT: 'parent',
  STUDENT: 'student',
  NURSE: 'nurse',
  PSYCHOLOGIST: 'psychologist',
  OMBUDSMAN: 'ombudsman',
  SECRETARY: 'secretary',
  FINANCE: 'finance'
}

const ADMINS = [roles.VERSAR_ADMIN, roles.SCHOOL_ADMIN]
const STAFF = [...ADMINS, roles.COORDINATOR]
const TEACHING = [...STAFF, roles.TEACHER]
const RESTRICTED = [roles.NURSE, roles.PSYCHOLOGIST, roles.OMBUDSMAN]
const MODERATORS = [roles.SCHOOL_MODERATOR, roles.CLASSROOM_MODERATOR]
const ALL_USERS = [
  ...TEACHING,
  ...MODERATORS,
  ...RESTRICTED,
  roles.STUDENT,
  roles.PARENT,
  roles.SECRETARY,
  roles.FINANCE
]
const CONTENT_CREATORS = [...STAFF, roles.CONTENT_CREATOR, roles.PSYCHOLOGIST]

export const accessMediations = [...TEACHING, ...MODERATORS]
export const accessForAdmins = ADMINS
export const accessForVersarAdmin = [roles.VERSAR_ADMIN]
export const accessVersarProgram = [...ADMINS, roles.CONTENT_CREATOR]
export const accessStudentsAndClassrooms = STAFF
export const accessClassrooms = TEACHING
export const accessPublishContent = [roles.SCHOOL_ADMIN]
export const accessSocioemotional = [...TEACHING, roles.PSYCHOLOGIST]
export const accessContents = [...STAFF, roles.PSYCHOLOGIST]
export const accessContentCreate = CONTENT_CREATORS
export const accessReportStudentDetail = [
  ...TEACHING,
  ...MODERATORS,
  ...RESTRICTED
]
export const accessReports = [
  ...STAFF,
  roles.PSYCHOLOGIST,
  roles.NURSE,
  roles.TEACHER
]
export const accessReportCreate = [...STAFF, ...MODERATORS]
export const accessAnnouncements = [...TEACHING, ...RESTRICTED]
export const accessAnnouncementsCreate = TEACHING
export const accessSwitchSchoolOrOccupation = [
  ...RESTRICTED,
  roles.SCHOOL_ADMIN,
  roles.TEACHER,
  roles.COORDINATOR
]
export const accessUtils = TEACHING
export const accessMaterials = TEACHING
export const accessMessages = ALL_USERS
export const accessMessagesInbox = [
  roles.VERSAR_ADMIN,
  roles.SCHOOL_ADMIN,
  roles.TEACHER,
  roles.SCHOOL_MODERATOR,
  roles.COORDINATOR
]
export const accessSettings = ALL_USERS
export const accessVersarOnly = [roles.VERSAR_ADMIN]
export const accessVersarAndSchoolAdmin = ADMINS
export const accessSettingsClassrooms = [...ADMINS, roles.COORDINATOR]
export const accessRooms = ALL_USERS
export const accessMessagesBase = [
  roles.SCHOOL_ADMIN,
  roles.TEACHER,
  roles.SCHOOL_MODERATOR,
  roles.COORDINATOR
]
export const accessPickup = [
  roles.SCHOOL_ADMIN,
  roles.TEACHER,
  roles.SCHOOL_MODERATOR,
  roles.COORDINATOR
]
export const accessHomepage = [
  ...accessPickup,
  ...RESTRICTED,
  roles.FINANCE,
  roles.SECRETARY
]

export const roomDepartment = {
  [roles.NURSE]: 1,
  [roles.PSYCHOLOGIST]: 3,
  [roles.OMBUDSMAN]: 2
}

export const occupationsIds = {
  VERSAR_ADMIN: '1',
  SCHOOL_ADMIN: '2',
  CONTENT_CREATOR: '3',
  COORDINATOR: '6',
  TEACHER: '8',
  STUDENT: '9',
  PARENT: '10',
  SCHOOL_MODERATOR: '11',
  CLASSROOM_MODERATOR: '12',
  DOORMAN: '14'
}

export const frequencyTags = {
  frequencyForAll: 'Frequência-O aluno compareceu a escola?',
  frequencyForSubject:
    'Frequência por Disciplina-O aluno compareceu a essa disciplina?',
  frequencyForAllTopic: 'O aluno compareceu a escola?',
  frequencyForSubjectTopic: 'O aluno compareceu a essa disciplina?',
  frequencyForAllName: 'Frequência',
  frequencyForSubjectName: 'Frequência por Disciplina'
}

export const shiftOptions = [
  {
    label: 'Manhã',
    value: 'morning'
  },
  {
    label: 'Tarde',
    value: 'afternoon'
  },
  {
    label: 'Integral',
    value: 'fulltime'
  },
  {
    label: 'Noite',
    value: 'night'
  },
  {
    label: 'Turno não definido',
    value: ''
  }
]

export const statusCommunication = {
  pending: 'Moderação',
  ongoing: 'Em andamento',
  done: 'Todas mensagens lidas',
  empty: '-'
}

export const acceptedFiles = [
  'application/pdf',
  'application/x-rar-compressed',
  'application/msword',
  'application/zip',
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/gif',
  'video/mp4',
  'video/mov',
  'video/quicktime',
  'audio/mpeg',
  'audio/mpeg3',
  'audio/mp4',
  'audio/m4a',
  'audio/x-m4a',
  'video/3gpp',
  'audio/3gpp',
  'video/3gpp2',
  'audio/3gpp2',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation'
]

export const statusMessage = {
  open: 'Em aberto',
  pending: 'Aguardando moderação',
  done: 'Lidas',
  refused: 'Recusada'
}

export const statusEvent = {
  open: 'Em aberto',
  pending: 'Aguardando moderação',
  done: 'Concluído',
  refused: 'Recusada',
  scheduled: 'Agendado'
}

export const destinationTypeEvent = {
  teachers: 'Docentes',
  parents: 'Responsáveis',
  students: 'Estudantes',
  individual: 'Individual'
}

export const utilsTypes = {
  menus: 'Cardápio',
  messages: 'Recado',
  documents: 'Documento',
  docs_pdf: 'Doc. PDF',
  links: 'Link',
  bulletins: 'Boletim',
  wrapper: 'Boletins'
}

export const eventsTypes = {
  events: 'evento',
  images: 'foto',
  communications: 'comunicado'
}

export const segmentedTags = {
  schoolsRoutine: [
    'Frequência',
    'Frequência por Disciplina',
    'Atraso',
    'Uniforme',
    'Lição de Casa',
    'Conteúdo Ministrado',
    'Tarefa',
    'Tarefa de casa',
    'Conteúdo do dia',
    'Ocorrências'
  ],
  fooding: [
    'Alimentação',
    'Alimentação Matutino',
    'Alimentação Vespertino',
    'Lanche',
    'Refeições',
    'Alimentação do dia'
  ],
  health: [
    'Higiene',
    'Evacuou',
    'Banho',
    'Necessidades Fisiológicas',
    'Enfermaria'
  ],
  rest: ['Sono', 'Dormiu', 'Hora da soneca'],
  comunication: ['Recado', 'Recado para turma']
}

export const reportStatus = {
  open: 'Em aberto',
  pending: 'Pendente',
  done: 'Concluído',
  waiting_moderation: 'Moderação'
}

export const queuesStatus = {
  pending: 'Pendente',
  finished: 'Concluído',
  exited: 'Desistiu'
}

export const reportsShift = {
  undefined: 'Não definido',
  morning: 'Manhã',
  afternoon: 'Tarde',
  fulltime: 'Integral',
  night: 'Noite'
}

export const months = {
  '01': 'janeiro',
  '02': 'fevereiro',
  '03': 'março',
  '04': 'abril',
  '05': 'maio',
  '06': 'junho',
  '07': 'julho',
  '08': 'agosto',
  '09': 'setembro',
  '10': 'outubro',
  '11': 'novembro',
  '12': 'dezembro'
}

export const occupationsArray = [
  [1, 'Administrador'],
  [2, 'Administrador da escola'],
  [8, 'Professor(a)'],
  [9, 'Estudante'],
  [10, 'Responsável'],
  [6, 'Coordenador'],
  [14, 'Controlador'],
  [13, 'Enfermeiro(a)'],
  [7, 'Psicólogo(a)']
]

export const relationOptions = [
  {
    label: 'Selecione parentesco',
    value: ''
  },
  {
    label: 'Pai/Mãe',
    value: 'progenitor',
    enum: 0
  },
  {
    label: 'Avô/Avó',
    value: 'grandparent',
    enum: 1
  },
  {
    label: 'Irmão/Irmã',
    value: 'sibling',
    enum: 2
  },
  {
    label: 'Próprio Aluno',
    value: 'themself',
    enum: 3
  },
  {
    label: 'Outro',
    value: 'other',
    enum: 4
  }
]

export const days = [
  { label: 'Segunda-feira', value: 'monday', acronym: 'Seg' },
  { label: 'Terça-feira', value: 'tuesday', acronym: 'Ter' },
  { label: 'Quarta-feira', value: 'wednesday', acronym: 'Qua' },
  { label: 'Quinta-feira', value: 'thursday', acronym: 'Qui' },
  { label: 'Sexta-feira', value: 'friday', acronym: 'Sex' },
  { label: 'Sábado', value: 'saturday', acronym: 'Sab' },
  { label: 'Domingo', value: 'sunday', acronym: 'Dom' }
]

export const colors = ['#EF7B8E', '#8A588D', '#555555', '#9DD2DA', '#F4A77B']

export const errors = {
  'taxpayer_number#taken': 'CPF inserido já consta em nossos dados.',
  'base#taken':
    'Este perfil já está salvo em nossos dados e você pode tentar reativá-lo.',
  'taxpayer_number#taken/parent':
    'CPF do responsável já consta em nossos dados.'
}
